// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1PQBl","topBottomGutter":"Layout_topBottomGutter__1HX4C"};